import { connect } from 'react-redux';
import AddNote from './AddNote';
import { createNote } from '../../redux';

export default connect(null, { saveNote: createNote })(AddNote);
